// T-228: la IA mide el texto en tokens; la UI lo muestra en palabras aproximadas.
// Misma relación que CreditCalculator: 500 palabras ≈ 650 tokens.
export const TOKENS_PER_WORD = 1.3;
export const tokensToWords = (tokens) => Math.round((Number(tokens) || 0) / TOKENS_PER_WORD);
// Texto de ayuda reutilizable (lenguaje llano):
export const WORDS_HELP =
  'Cantidad aproximada de palabras que la IA va a leer con tu mensaje. ' +
  'La IA en realidad mide el texto en "tokens" (pedazos de palabra, ~1.3 por palabra); ' +
  'aquí te lo mostramos en palabras para que sea fácil de entender. ' +
  'Más palabras = más créditos consumidos y respuesta más lenta.';
